import React, {forwardRef} from 'react'
import PropTypes from 'prop-types'
import PerfectScrollbar, {ScrollBarProps} from 'react-perfect-scrollbar'
import 'react-perfect-scrollbar/dist/css/styles.css'


interface Props {
  children: React.ReactNode;
  options?: ScrollBarProps['options']
}
const Scrollbar : React.FC<Props>  = forwardRef<PerfectScrollbar, Props>((props, ref) => {
  const {children, ...other} = props
  
  return (
    <PerfectScrollbar ref={ref} {...other}>
      {children}
    </PerfectScrollbar>
  )
})

Scrollbar.propTypes = {
  children: PropTypes.node,
}

export default Scrollbar
